// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-add-to-cart-modal--with-sub-modal .modal-body{overflow:hidden}", ""]);
// Exports
module.exports = exports;
